import React from "react";
import { Box, Typography, Grid, Card, CardMedia, CardContent } from "@mui/material";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";

export default function TeamSection({ data, headingText, subHeadingText }) {
  return (
    <Box sx={{ textAlign: "center", py: 6, backgroundColor: COLORS.lightGrey }}>
      {/* Section Heading */}
      <Typography
        variant="subtitle1"
        sx={{ color: COLORS.primaryColor, fontWeight: "bold", letterSpacing: 1 }}
        gutterBottom
        fontFamily={fontFamilyAll}
      >
        {headingText}
      </Typography>
      <Typography
        variant="h4"
        fontWeight="bold"
        color={COLORS.blackColor}
        gutterBottom
        fontFamily={fontFamilyAll}
      >
        {subHeadingText}
      </Typography>

      {/* Team Members Grid */}
      <Grid container spacing={4} mt={2} justifyContent="center" p={2}>
        {data.map((member) => (
          <Grid item key={member.id} xs={12} sm={6} md={3} lg={2.5}>
            <Card
              elevation={0}
              sx={{
                borderRadius: "12px",
                overflow: "hidden",
                bgcolor: "transparent",
                "&:hover img": {
                  transform: "scale(1.05)",
                },
              }}
            >
              {/* Image */}
              <CardMedia
                component="img"
                height="320"
                image={member.image}
                alt={member.name}
                sx={{
                  borderRadius: "12px",
                  transition: "transform 0.4s ease-in-out",
                }}
              />

              {/* Text Section */}
              <CardContent sx={{ textAlign: "center", p: 2 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: COLORS.primaryColor }}
                  fontFamily={fontFamilyAll}
                >
                  {member.name}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: COLORS.blackColor, opacity: 0.8 }}
                  fontFamily={fontFamilyAll}
                >
                  {member.role}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
